<template>
  <div class="app-container">
    <el-card shadow="never">
      <div class="filter-container">
        <div class="searchContainer">
          <label class="inputLabel">app_id：</label>
          <el-input
            v-model="advertisersQuery.app_id"
            placeholder="请输入内容"
          />
        </div>
        <div class="searchContainer">
          <label class="inputLabel">类型：</label>
          <el-select v-model="advertisersQuery.type" placeholder="请选择">
            <el-option
              v-for="item in accountType"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </div>
        <div class="searchContainer">
          <label class="inputLabel">状态：</label>
          <el-select v-model="advertisersQuery.status" placeholder="请选择">
            <el-option
              v-for="item in accountStatus"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </div>
        <el-button
          class="filter-item"
          type="primary"
          icon="el-icon-search"
          @click="handleSearch"
        >
          搜索
        </el-button>
        <el-button
          class="filter-item"
          type="primary"
          icon="el-icon-refresh"
          @click="handleSearchReset"
        >
          重置
        </el-button>
        <!-- <el-button
          icon="el-icon-download"
          class="filter-item"
          type="success"
          @click="pullAll"
        >批量拉取素材报表</el-button> -->
        <!-- <el-button
          icon="el-icon-plus"
          class="filter-item"
          type="warning"
          @click="addadvr"
        >新增</el-button> -->
      </div>
      <el-table
        v-loading="loading"
        :data="tableData"
        highlight-current-row
        :header-cell-style="{ background: '#eef1f6', color: '#606266' }"
        class="border-gray"
        fit
        style="width: 100%; justify-content: space-between"
      >
        <el-table-column prop="id" label="id" align="center" width="80" />
        <el-table-column
          prop="app_id"
          label="app_id"
          align="center"
          width="180"
        />
        <el-table-column prop="app_name" label="公众号名称" align="center" width="180" />
        <el-table-column align="center" prop="channel_name" label="视频号名称" />
        <el-table-column align="center" prop="auth_scope_desc" label="授权范围" />
        <el-table-column align="center" prop="relationship_desc" label="合作关系" />
        <el-table-column
          prop="stock_screenshot_url"
          label="股权截图"
          align="center"
        >
          <template slot-scope="scope">
            <el-image
              style="width: 100px; height: 100px"
              :src="scope.row.stock_screenshot_url"
              :preview-src-list="[scope.row.stock_screenshot_url]"
              @click.stop="handleClickStop"
            />
          </template>
        </el-table-column>
        <el-table-column prop="type_desc" label="类型" align="center" />
        <el-table-column
          prop="auth_ttl_day_desc"
          label="过期时间"
          align="center"
        />
        <el-table-column prop="status" label="状态" align="center">
          <template slot-scope="scope">
            {{ scope.row.status | filterStatus }}
          </template>
        </el-table-column>
        <el-table-column prop="account_ids" label="广告主" align="center">
          <template slot-scope="scope">
            <el-popover
              v-if="scope.row.account_ids"
              trigger="hover"
              width="500"
            >
              <template slot="reference">
                <el-tag
                  style="margin-right: 10px; margin-bottom: 5px"
                >更多</el-tag>
              </template>
              <div
                v-for="item in scope.row.account_ids"
                :key="item"
                style="
                  display: inline-block;
                  margin-right: 10px;
                  margin-bottom: 5px;
                "
              >
                <el-tag> {{ item }}</el-tag>
              </div>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column
          prop="created_at"
          label="创建时间"
          align="center"
          width="180"
        />
        <el-table-column fixed="right" label="操作" width="200">
          <template slot-scope="scope">
            <el-button
              v-if="scope.row.url !== null"
              type="primary"
              icon="el-icon-download"
              @click="clickExport(scope.row)"
            >导出</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination-right
        :total="total"
        @size-change="fetchPageSize"
        @current-change="fetchCurrentPage"
      />
    </el-card>
    <CodeScanning
      ref="codeScanning"
      :title="
        typeValue === 'QQ'
          ? 'QQ扫码登录'
          : typeValue === '微信'
            ? '微信扫码登录'
            : typeValue
      "
      :myobj="mStyle[typeValue] || {}"
      @reset="reset"
    />
    <el-dialog
      title="批量拉取"
      :visible.sync="dialogVisiblePull"
      width="600px"
      :before-close="handleClose"
    >
      <detailsList ref="pull" @addPull="addPull" />
    </el-dialog>
    <el-dialog
      title="授权账户"
      :visible.sync="dialogVisibleadr"
      :destroy-on-close="true"
      :close-on-click-modal="false"
      width="600px"
    >
      <addAD ref="addadview" @callbackbacer="updata" />
    </el-dialog>
  </div>
</template>

<script>
import PaginationRight from '@/components/PaginationRight/index.vue'
import {
  change_name,
  change_app_id,
  advertisers,
  auth_accountTask_record
} from '@/api/customer.js'
import { getURL, getBalance } from '@/api/report/accountManagement'
import detailsList from '../../customer/accountList/components/details.vue'
import CodeScanning from '../../customer/accountList/codeScanningLogin/index.vue'
import addAD from './components/addAuthorization.vue'
// import XLSX from 'xlsx'
let that
export default {
  name: 'AccountList',
  components: {
    PaginationRight,
    CodeScanning,
    detailsList,
    addAD
    // AdminAdvertAdd
  },
  filters: {
    // 用于过滤主要运营人员 如果 is_master 为 1 则 relation_name 就是主要运营成员
    filterMaster(currentData) {
      for (let i = 0; i < that.accountType.length; i++) {
        if (that.accountType[i].value === currentData) {
          return that.accountType[i].label
        }
      }
    },
    filterStatus(currentData) {
      for (let i = 0; i < that.accountStatus.length; i++) {
        if (that.accountStatus[i].value === currentData) {
          return that.accountStatus[i].label
        }
      }
    }
  },
  data() {
    return {
      tableData: [],
      search: {},
      total: null, // 数据总条数啊
      // table列表数据请求参数
      advertisersQuery: {
        name: null,
        type: null, // 广告主名称
        app_id: null, // 广告组名称
        // type: null,
        page: null, // 当前页码
        page_size: null // 广告在系统中的状态
      },
      // 枚举值请求参数
      enumerationsQuery: {
        account_id: null,
        api_name: 'account_management/advertisers'
      },
      // 账号类型
      accountType: [
        {
          value: 1,
          label: '视频号'
        },
        {
          value: 2,
          label: '广告专用视频号管理'
        },
        {
          value: 3,
          label: '公众号'
        },
        {
          value: 4,
          label: '搜一搜超级品专关键词'
        },
        {
          value: 5,
          label: '小游戏/小程序'
        },
        {
          value: 101,
          label: '企业微信'
        }
      ],
      accountStatus: [
        {
          value: 1,
          label: '待处理'
        },
        {
          value: 2,
          label: '成功'
        },
        {
          value: 3,
          label: '失败'
        },
        {
          value: 4,
          label: '部分失败'
        }
      ],
      accountIdsQuery: [], // 获取用户余额的参数
      loading: false, // 加载动画
      dialogVisible: false,
      dialogVisiblePull: false,
      moneyLoading: false, // 余额加载动画
      mantle: false,
      source: null,
      typeValue: '',
      mStyle: {},
      activeItem: null,
      activeItemId: null,
      activeText: null,
      activeTextid: null,
      dialogVisibleadr: false,
      alone: null
    }
  },
  created() {
    this.getAdvertiserList()
  },
  beforeCreate() {
    that = this
  },
  methods: {
    copy(row) {},
    async addPull(obj) {
      console.log('obj:', obj)
      await advertisers(obj)
      this.$message.success('批量拉取成功')
      this.dialogVisiblePull = false
    },
    handleClose() {
      this.dialogVisiblePull = false
    },
    pullAll() {
      this.dialogVisiblePull = true
      this.$nextTick(() => {
        this.$refs.pull.sendr()
      })
    },
    async blur1() {
      if (this.activeItem.consume !== this.activeText) {
        try {
          await change_name({
            id: this.activeItem.id,
            account_name: this.activeText
          })
          this.$message({
            message: '修改成功',
            type: 'success'
          })
          this.getAdvertiserList()
        } catch (err) {
          this.activeItem = null
          this.activeText = null
        }
      }
      this.activeItem = null
      this.activeText = null
    },
    async blur2() {
      if (this.activeItemId.consume !== this.activeTextid) {
        try {
          await change_app_id({
            id: this.activeItemId.id,
            app_id: this.activeTextid
          })
          this.$message({
            message: '修改成功',
            type: 'success'
          })
          this.getAdvertiserList()
        } catch (err) {
          this.activeItemId = null
          this.activeTextid = null
        }
      }
      this.activeItemId = null
      this.activeTextid = null
    },

    getAdvertiserList() {
      this.loading = true
      auth_accountTask_record(this.advertisersQuery).then((res) => {
        console.log('res:', res)
        this.tableData = res.data.list
        this.total = res.data.count
        this.loading = false
        console.log(22)
        // res.data.list.length > 0 && this.getBalanceData()
        // this.tableData[0].advertiser_relation[0].is_master = 1
      })
    },
    clickExport(row) {
      if (row.url === null) {
        this.$message({
          type: 'error',
          message: '请不要导出空数据'
        })
        return
      }
      console.log('row.url 66:', row)
      window.open(row.url, '_blank')
      // const link = document.createElement('a')
      // link.href = row.url // 使用row.url作为Excel文件的URL
      // // link.download = '文件名.xlsx' // 设置要保存的文件名
      // link.style.display = 'none'
      // document.body.appendChild(link)
      // link.click()
      // document.body.removeChild(link)
    },
    getURLData(item) {
      this.dialogVisible = true
      if (item === '微信') {
        getURL().then((res) => {
          window.open(res.data.advertiser)
        })
      } else {
        this.typeValue = 'QQ'
        this.$refs.codeScanning.open()
      }
    },
    // 获取用户余额
    getBalanceData() {
      this.moneyLoading = true
      console.log('过来了')
      getBalance({ account_ids: this.accountIdsQuery.toString() }).then(
        (res) => {
          const arr = []
          for (let i = 0; i < res.data.length; i++) {
            arr[i] = res.data[i].account
          }
          for (let i = 0; i < this.tableData.length; i++) {
            const index = arr.indexOf(this.tableData[i].account_id)
            if (index !== -1) {
              this.tableData[i].money = res.data[index].balance
            }
          }
          this.accountIdsQuery = []
          this.moneyLoading = false
        }
      )
    },
    // 关闭iframe
    closeDialog() {
      this.dialogVisible = false
      this.authorizeURLData = null
    },
    // 抓取分页数据
    fetchPageSize(data) {
      this.advertisersQuery.page_size = data
      this.getAdvertiserList()
    },
    // 抓取当前页数据
    fetchCurrentPage(data) {
      this.advertisersQuery.page = data
      this.getAdvertiserList()
    },
    // 搜索
    handleSearch() {
      this.advertisersQuery.page = 1
      this.advertisersQuery.page_size = 10
      this.getAdvertiserList()
    },
    // 重置搜索框
    handleSearchReset() {
      this.advertisersQuery = {}
      this.getAdvertiserList()
    },
    handleCommand(command, data) {
      switch (command) {
        case 'dataReport':
          this.$router.push({
            name: 'EffectData',
            params: {
              account_id: data.account_id,
              account_name: data.account_name
            }
          })
          break
      }
    },
    handleClickStop() {
      this.$nextTick(() => {
        const domImageView = document.querySelector('.el-image-viewer__mask') // 获取遮罩层dom
        if (!domImageView) {
          return
        }
        domImageView.addEventListener('click', () => {
          // 点击遮罩层时调用关闭按钮的 click 事件
          document.querySelector('.el-image-viewer__close').click()
        })
      })
    },
    reset(callback) {
      callback()
      this.source && this.source()
    },

    // 清除
    eliminate(id) {
      this.$confirm('你确定是否删除账号?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async() => {
        // await adq_mkt_api_authManageDELETE(id)
        this.$message({
          type: 'success',
          message: '删除成功!'
        })
        this.getAdvertiserList()
      })
    },
    addadvr() {
      this.dialogVisibleadr = true
      this.$nextTick(() => {
        this.$refs.addadview.sendr()
      })
    },
    updata() {
      this.dialogVisibleadr = false
      this.getAdvertiserList()
    }
  }
}
</script>

<style lang="less" scoped>
::v-deep .block {
  justify-content: left;
}
.searchContainer {
  display: flex;
  font-size: 14px;
  float: left;
  margin-right: 30px;
  label {
    padding-top: 10px;
    vertical-align: middle;
    font-weight: normal;
  }
  .inputLabel {
    // display: inline-block;
    width: 100px;
  }
}

.overflow {
  cursor: pointer;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
</style>
